import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import { SvgProps } from 'react-native-svg';

const ICON_PLACEHOLDER = '[icon]';

interface Props {
  Icon: React.FC<SvgProps>;
  iconProps?: SvgProps;
  message: string;
}

export const IconText: React.FC<Props> = ({ Icon, iconProps, message }) => {
  const iconIndex = message.indexOf(ICON_PLACEHOLDER);
  const content =
    iconIndex === -1
      ? message
      : [
          message.slice(0, iconIndex),
          <View key="icon" style={styles.iconContainer}>
            <Icon height={24} {...iconProps} />
          </View>,
          message.slice(iconIndex + ICON_PLACEHOLDER.length),
        ];

  return <>{content}</>;
};

const styles = StyleSheet.create({
  iconContainer: {
    alignItems: 'center',
    height: Platform.select({
      android: 16,
      default: 20,
    }),
    justifyContent: 'center',
    width: 32,
  },
});
